<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
            <v-col cols="12" class="px-0 py-5">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Monthly Retailer Sales Report
                    <div class="month-label">
                      {{
                        `${formatDate(this.dates[0])} - ${formatDate(
                          this.dates[1]
                        )}`
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Dates
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(dates)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-toolbar>

          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-col>

      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Retailer / Dealer
                  </v-toolbar-title>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.Name`]="{ item }">
              <a href="#" @click.prevent="showRetailerSales(item)">{{
                item.Name
              }}</a>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <RetailerSalesList ref="retailerSalesList" />
  </v-container>
</template>

<script>
import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
import RetailerSalesList from "../dialogs/dealerRetailer/RetailerSalesList.vue";
export default {
  mixins: [ShareableMethods],
  components: { RetailerSalesList },
  data() {
    return {
      currentCity: "All",
      cities: ["All"],
      dates: [
        moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment(this.date)
          .endOf("month")
          .format("YYYY-MM-DD"),
      ],
      menu: false,
      modal: false,
      search: "",
      table: {
        loading: false,
        headers: [
          {
            text: "Retailer Name",
            sortable: false,
            value: "Name",
            // formatter: (x) => (x ? moment(x).format("MMM DD") : null),
          },
          {
            text: "Dealer Name",
            sortable: false,
            value: "dealerName",
            // formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "Gross Sales",
            sortable: false,
            value: "Gross Sales",
            formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "Province",
            sortable: false,
            value: "province",
            // formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "City",
            sortable: false,
            value: "City",
            // formatter: (x) => this.setToLocaleString(x),
          },
        ],
        data: [],
      },
    };
  },

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$drs
        .get(
          `/data-report?method=retailerSalesReportList&startDate=${this.dates[0]}&endDate=${this.dates[1]}`
        )
        .then((response) => {
          this.table.loading = false;
          const newArr = response.data.data;
          if (newArr.list.response_code == "4") {
            return;
          }
          this.table.data = newArr.list;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    formatDate(d) {
      return moment(d).format("MMM DD, YYYY");
    },

    async showRetailerSales(item) {
      console.log(item);
      await this.$refs.retailerSalesList.open(item);
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    dates() {
      this.getList();
    },
    currentCity() {
      this.getList();
    },
  },

  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
